import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* paymentUnsettle(action: ActionInterface): any {
  try {

    yield call(Http.put, `payment/${action.payload?.payment.id}/unsettle`);

    yield put({
      type: Constants.GLOBAL_PAYMENT_UNSETTLE_SUCCESS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-unsettled-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_UNSETTLE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentUnsettle() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_UNSETTLE_START, paymentUnsettle);
}
